module.exports = __webpack_public_path__ + "static/media/1.17cf51b1.jpg";